import {
  binAssignmentSessionIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

export const createBinAssignmentSession = {
  name: "createBinAssignmentSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
};

export const getBinAssignmentSession = {
  name: "getBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        binNames: z.array(z.string()),
        productTitle: z.string(),
        productSku: z.string().nullable(),
        productImageUrl: z.string().nullable(),
        productBarcode: z.string().nullable(),
      }),
    ),
    createdAt: z.string(),
    completedAt: z.string().nullable(),
  }),
};

export const getActiveBinAssignmentSessions = {
  name: "getActiveBinAssignmentSessions" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    sessions: z.array(
      z.object({
        sessionId: binAssignmentSessionIdFormat.schema,
        productCount: z.number(),
        createdAt: z.string(),
      }),
    ),
  }),
};

export const upsertBinAssignmentProduct = {
  name: "upsertBinAssignmentProduct" as const,
  input: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    productId: productIdFormat.schema,
    binNames: z.array(z.string()),
  }),
  output: z.object({ success: z.boolean() }),
};

export const removeBinAssignmentProduct = {
  name: "removeBinAssignmentProduct" as const,
  input: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    productId: productIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};

export const completeBinAssignmentSession = {
  name: "completeBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({
    success: z.boolean(),
    productsUpdated: z.number(),
    errors: z.array(z.string()),
  }),
};

export const cancelBinAssignmentSession = {
  name: "cancelBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
